<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <el-row>
            <el-col :span="4">
              <a href="/workflow/flowHistory">
                <el-statistic title="待办记录数" :value="result.todoCount" />
              </a>
            </el-col>
            <el-col :span="4">
              <a href="/order/preInfo">
                <el-statistic title="今日总订单数(本部门)" :value="result.orderTotalCount || 0" />
              </a>
            </el-col>
            <el-col :span="4">
              <a href="/order/preInfo0">
                <el-statistic title="今日待确认订单(本部门)" :value="result.orderNewCount || 0" />
              </a>
            </el-col>
            <el-col :span="4">
              <a href="/order/preInfo">
                <el-statistic title="今日销售额(本部门)" :value="result.orderTotalAmount || 0" />
              </a>
            </el-col>
            <el-col :span="4">
              <a href="/order/returnInfo">
                <el-statistic title="今日售后订单(本部门)" :value="result.returnTotalCount || 0" />
              </a>
            </el-col>
            <el-col :span="4">
              <a href="/order/returnInfo">
                <el-statistic title="今日售后金额(本部门)" :value="result.returnTotalAmount || 0" />
              </a>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-top:12px;">
      <el-col :span="12">
        <el-card>
          <div slot="header" class="clearfix" style="margin-bottom: 12px;">
            <h5>我的审批单据</h5>
          </div>

          <el-table class="table" :data="todoList" border size="small" style="width: 100%">
            <el-table-column type="index" label="序" align="center" width="40"> </el-table-column>
            <el-table-column prop="billCode" label="单据编号" width="135" show-overflow-tooltip>
              <template #default="scope">
                <a :href="scope.row.formUrl">{{ scope.row.billCode }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="flowName" label="流程名称" width="100" show-overflow-tooltip>
              <template #default="scope">
                {{ scope.row.flowName || scope.row.formName }}
              </template>
            </el-table-column>
            <el-table-column prop="formDesc" label="单据描述" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createDate" label="创建时间" width="90" align="center">
              <template #default="scope">
                {{ $util.fmtDate(scope.row.createDate, "MM-dd HH:mm") }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div slot="header" class="clearfix" style="margin-bottom: 12px;">
            <h5>部门最新订单</h5>
          </div>

          <el-table class="table" :data="orderList" border size="small" style="width: 100%">
            <el-table-column type="index" label="序" align="center" width="40"> </el-table-column>
            <el-table-column prop="billCode" label="订单号" width="100" show-overflow-tooltip>
              <template #default="scope">
                <a href="/order/preInfo">{{ scope.row.platformOrderNo }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="platformName" label="渠道" width="55" show-overflow-tooltip></el-table-column>
            <el-table-column prop="departmentName" label="部门" width="70" show-overflow-tooltip></el-table-column>
            <el-table-column prop="itemTradeFee" label="金额" width="70" show-overflow-tooltip></el-table-column>
            <el-table-column prop="itemSpec" label="规格" show-overflow-tooltip></el-table-column>
            <el-table-column prop="platformOrderDate" label="订单时间" width="90" align="center">
              <template #default="scope">
                {{ $util.fmtDate(scope.row.platformOrderDate, "MM-dd HH:mm") }}
              </template>
            </el-table-column>
          </el-table>

        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-top:12px;">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="clearfix" style="margin-bottom: 12px;">
            <h5>部门最新采购货品</h5>
          </div>

          <el-table class="table" :data="boundList" border size="small" style="width: 100%">
            <el-table-column type="index" label="序" align="center" width="40"> </el-table-column>
            <el-table-column prop="billCode" label="款号" width="135" show-overflow-tooltip>
              <template #default="scope">
                <a :href="'/stock/bound/index?detailCode=' + scope.row.detailCode">{{ scope.row.detailCode }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="flowName" label="图片" width="60">
              <template #default="scope">
                <el-image style="height: 32px; width: 32px" lazy
                  :src="apiUrl + 'static/code/' + scope.row.detailCode + '?t=0'"
                  :preview-src-list="[apiUrl + 'static/code/' + scope.row.detailCode + '?t=1']">
                  <template #error>
                    <img style="width: 100%" src="~@/assets/imgunfine.jpg"
                      :data-src="'static/code/' + scope.row.detailCode + '?t=1'" alt="" />
                  </template>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="detailName" label="产品名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="brandName" label="品牌" width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="unitPrice" label="单价" width="90" show-overflow-tooltip></el-table-column>
            <el-table-column prop="productPrice" label="总价" width="90" show-overflow-tooltip></el-table-column>
            <el-table-column prop="stockNumber" label="数量" width="60" show-overflow-tooltip></el-table-column>
            <el-table-column prop="channel" label="渠道" width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="storeCode" label="库房" width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="stockDate" label="入库时间" width="90" align="center">
              <template #default="scope">
                {{ $util.fmtDate(scope.row.stockDate, "MM-dd HH:mm") }}
              </template>
            </el-table-column>
          </el-table>

        </el-card>
      </el-col>
    </el-row>
  </div>
  <!-- <example class="example" />
  <hr />
  <static-dialog class="dialog" title="编辑" :visible="false">
    <div>1234</div>
  </static-dialog> -->

  <static-dialog ref="resetDialog" class="dialog" title="重置密码" :ok="resetPwdEvent">
    <resetPwdDialog :visible="true" title="密码过于简单，需要重置该默认密码" ref="resetPwdDialogRef"></resetPwdDialog>
  </static-dialog>

</template>
<script>
import resetPwdDialog from "@/views/sys/user/reset.vue";
import StaticDialog from "@/components/static-dialog.vue";
//import Example from "@/components/example.vue";
//import StaticDialog from "@/components/static-dialog.vue";
export default {
  name: "default",
  components: { resetPwdDialog, StaticDialog },
  data() {
    return {
      apiUrl: '',
      //resetDialogVisible: false,
      result: {},
      todoList: [],
      orderList: [],
      boundList: [],
    };
  },
  methods: {
    resetPwdEvent() {
      this.$refs.resetPwdDialogRef.resetPwd(1);

    },
  },
  mounted() {
    this.$kaung.fetch({ url: '/Console/UserCenter', method: 'get' }).then((res) => {
      this.result = res.data.report;
      this.todoList = res.data.todoList;
      this.orderList = res.data.orderList;
      this.boundList = res.data.boundList;
    });
    if (this.$route.query.type == 'simple') {
      this.$message.error("密码过于简单，请重置默认密码");
      //this.$emit('openPwd');
      //this.resetDialogVisible = true;
      this.$refs.resetDialog.toggle();

    }
  },
  created() {
    this.apiUrl = process.env.VUE_APP_BASEURL;
    //console.log(this.$route.query.type)
  },
};
</script>